import { render } from "./Javascript.vue?vue&type=template&id=3442b198"
import script from "./Javascript.vue?vue&type=script&lang=js"
export * from "./Javascript.vue?vue&type=script&lang=js"

import "./Javascript.vue?vue&type=style&index=0&id=3442b198&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__